import { z } from 'zod'

export const UserSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().nullish(),
  phone: z.string().nullish()
})
